import React from 'react';
import { Link } from 'react-router-dom';

export default function ForbiddenPage() {
  return (
    <>
      <title>Ingen adgang - Rolskov Bowtech</title>
      <section className="py-20 lg:py-28 bg-[#faf8f5]">
        <div className="max-w-3xl mx-auto px-4 text-center space-y-8">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#e8f5ed] text-[#228A47] text-3xl font-bold">
            403
          </div>

          <div className="space-y-3">
            <h1 className="text-3xl sm:text-4xl font-bold text-[#062364]">
              Der er desværre ingen adgang til denne side
            </h1>
            <p className="text-base text-[#132038] max-w-xl mx-auto">
              Du har ikke rettigheder til at tilgå denne ressource. Du kan gå tilbage til forsiden eller kontakte klinikken.
            </p>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 pt-2">
            <Link
              to="/"
              className="px-6 py-3.5 text-sm font-semibold text-white bg-[#228A47] hover:bg-[#1b713a] rounded-xl shadow-xs transition-colors"
            >
              Gå til forsiden
            </Link>
          </div>

          <div className="pt-8 border-t border-[#228A47]/10 space-y-3">
            <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider">
              Har du spørgsmål?
            </p>
            <div className="flex flex-wrap justify-center gap-6 text-sm font-bold text-[#062364]">
              <a href="tel:27117557" className="whitespace-nowrap hover:text-[#228A47] transition-colors flex items-center gap-2">
                <i className="fa-solid fa-phone text-[#228A47]" aria-hidden="true"></i>
                <span>27 11 75 57</span>
              </a>
              <a href="mailto:joern@rolskov-bowtech.dk" className="whitespace-nowrap hover:text-[#228A47] transition-colors flex items-center gap-2">
                <i className="fa-regular fa-envelope text-[#228A47]" aria-hidden="true"></i>
                <span>joern@rolskov-bowtech.dk</span>
              </a>
            </div>
          </div>

        </div>
      </section>
    </>
  );
}
